export default __webpack_public_path__ + "static/media/wild-boar.8b83a8f9.png";